import React from "react";
import Checkbox, { CheckboxProps } from "@mui/material/Checkbox";

export const StyledCheckbox: React.FC<CheckboxProps> = (props) => (
  <Checkbox
    sx={{
      "&": {
        margin: 0,
        padding: "5px",
        borderRadius: "5px !important",
        width: "1.5em",
        height: "1.5em",
        color: "#CFCFCF",
        background: "#FFF",
      },
      "&.Mui-checked": {
        border: "1px solid #00A603",
        color: "#CCF4CD",
        background: "#00A603",
      },
    }}
    {...props}
  />
);
